import React from 'react';
import {Button, Result} from 'antd';
import './index.scss';

const Error:React.FC<any> = props => {
    const {path} = props;
    return (
        <Result
            status="warning"
            title="Error"
            subTitle="服务器错误，请联系管理员或稍后重试"
            className="error-component"
            extra={(
                <Button
                    type="primary"
                    onClick={() => window.location.replace(path)}
                >重试</Button>
            )} />
    );
};

export default Error;